module.exports = __webpack_public_path__ + "img/Solutions-Catalog-Launch-967x683.89ede0df.png";